import React from 'react';
import TyC from '../../components/tyc_comp/tyc'; 

const TyCPage = () => {
    return (
        <main >
            <TyC />
        </main>
    );
};

export default TyCPage;
